import React, { useEffect } from 'react';
import { useForm,Controller } from "react-hook-form";
import UploadFile from '../../UploadFile/UploadFile';

const StepThree = ({ activeStep, setActiveStep, nextStep, prevStep, setPaiement, paiement }) => {
  const { 
    handleSubmit,
    formState: { errors },
    setError: setFormError,
    control,
    trigger,
    clearErrors,
    setValue,
  } = useForm(); 

  const handleNext = () => {
    // Validate that at least one file is uploaded
    
    if (!paiement?.infovehicule?.dossier || paiement.infovehicule.dossier.length === 0) {
      setFormError("files", {
        type: "manual",
        message: "Vous devez uploader un fichier PDF"
      });
      return;
    }
    
    // Clear any existing errors
    clearErrors("files");
    nextStep();
  };
 // Initialize form value when component mounts or paiement changes
 useEffect(() => {
    setValue("files", paiement?.infovehicule?.dossier || []);
    if (paiement?.infovehicule?.dossier?.length > 0) {
      clearErrors("files");
    } else {
      trigger("files");
    }
  }, [paiement.infovehicule.dossier, setValue, clearErrors, trigger]);
  //console.log(paiement.infovehicule);
  return (
    <div className='step-component step-three'>
      <form onSubmit={handleSubmit(handleNext)}>
       <Controller
          name="files"
          control={control}
          rules={{
            validate: value => (value && value.length > 0) || "Vous devez uploader un fichier PDF"
          }}
          render={({ field, fieldState: { error } }) => (
            <UploadFile 
              paiement={paiement}
              setPaiement={setPaiement}
              formError={error}
              onFilesChange={(files) => {
                field.onChange(files);
                if (files && files.length > 0) {
                  clearErrors("files");
                }
              }}
            />
          )}
        />
        
        {errors.files && (
          <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
            {errors.files.message}
          </div>
        )}

        <div className="buttons">
          <button className="secondary" onClick={prevStep} type="button">
            Précedent
          </button>
          <button className="" type='submit'>
            Suivant
          </button>
        </div>
      </form>
    </div>
  );
}

export default StepThree;